import {Component, h, Prop} from '@stencil/core';


@Component({
    tag: 'lilu-hero-slider-tile',
    styleUrl: 'lilu-hero-slider-tile.scss',
    shadow: true
})
export class LiluHeroSliderTile {

  @Prop() bubble: boolean;
  @Prop() imageorvideo = '';
  @Prop() link = '';

  render() {
    return (
      <div class="hero-slider-tile">
        <a href={this.link}>
          {this.imageorvideo === 'image'
            ? <div><slot name="imageDesktop"></slot><slot name="imageMobile"></slot></div>
            : <slot name="video"></slot>
          }
          <slot></slot>
          {this.bubble
            ? <slot name="bubble"></slot>
            : ''
          }
        </a>
      </div>
    );
  }
}
